import {get, post} from "./api";

export default {
    login(credentials) {
        return get('/login', credentials)
    },

    signout(token) {
        return get('/signout', {token})
    },

    signon(params) {
        return get('/signon', params)
    },

    getPsswdCode(params) {
        return get('getPsswdCode', params)
    },

    resetPassword(params) {
        return get('/resetPsswd', params)
    },

    updateProfile(params) {
        return post('/updateProfileJSON', params)
    },

    getUserInfo(token) {
        return get('/getNameImage', {token})
    },

    collectReward(token) {
        return get('/rewardUser', {token})
    }
}
